import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import '../../styles/common/Footer.css';
import { companyDetails } from '../../data/siteData';

class Footer extends React.Component {
    state = {
        showFloatingBtns: false
    };

    componentDidMount() {
        const handleScroll = () => {
            if (window.scrollY >= 200) {
                this.setState({ showFloatingBtns: true });
            } else {
                this.setState({ showFloatingBtns: false });
            }
        };

        window.addEventListener('scroll', handleScroll);
    }

    render() {
        const logoIcon = require('./../../images/logo-icon.png');
        const bsCladsLogo = require('./../../images/bs-clads-logo.png');
        const { showFloatingBtns } = this.state;

        return (
            <>
                <footer className="site-footer footer-large footer-dark footer-wide" style={{ backgroundColor: '#111111' }}>
                    {/* FOOTER BLOCKES START - COMPACT PADDING */}
                    <div className="footer-top" style={{ backgroundColor: '#111111', paddingTop: '18px', paddingBottom: '10px' }}>
                        <div className="container">
                            <div className="row justify-content-between">
                                {/* ABOUT COMPANY */}
                                <div className="col-lg-4 col-md-12 footer-col-about">
                                    <div className="widget widget_about">
                                        <div className="logo-footer clearfix p-b15">
                                            <NavLink to={"/"} style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
                                                <img src={logoIcon} alt="BS Icon" style={{ height: '44px', width: 'auto', objectFit: 'contain' }} />
                                                <img src={bsCladsLogo} alt="bs clads" style={{ height: '44px', width: 'auto', objectFit: 'contain' }} />
                                            </NavLink>
                                        </div>
                                        <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '13.5px', textAlign: 'justify', margin: 0 }}>
                                            <strong>bs clads (Since 2010)</strong> is a premier specialist in architectural ACP Front Elevation, Facade Glazing, and Toughened Glass solutions, supported by skilled and trained professionals in <span style={{ whiteSpace: 'nowrap' }}>Coimbatore - 641 005</span>.
                                        </p>
                                        {/* <ul className="social-icons sx-social-links d-flex align-items-center" style={{ listStyle: 'none', padding: 0, gap: '12px', marginTop: '18px' }}>
                                            <li><a href="https://www.facebook.com" className="fa fa-facebook text-white p-a10" target="_blank" rel="noreferrer" style={{ backgroundColor: '#222', borderRadius: '50%', width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} aria-label="Facebook"><span className="sr-only">Facebook</span></a></li>
                                            <li><a href="https://twitter.com" className="fa fa-twitter text-white p-a10" target="_blank" rel="noreferrer" style={{ backgroundColor: '#222', borderRadius: '50%', width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} aria-label="Twitter"><span className="sr-only">Twitter</span></a></li>
                                            <li><a href="https://www.instagram.com" className="fa fa-instagram text-white p-a10" target="_blank" rel="noreferrer" style={{ backgroundColor: '#222', borderRadius: '50%', width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} aria-label="Instagram"><span className="sr-only">Instagram</span></a></li>
                                        </ul> */}
                                    </div>
                                </div>

                                {/* QUICK LINKS */}
                                <div className="col-lg-3 col-md-5 p-l40-lg footer-col-quicklinks">
                                     <div className="widget widget_services" style={{ paddingLeft: '10px' }}>
                                         <h5 className="widget-title text-white" style={{ borderBottom: '2px solid #f03a02', display: 'inline-block', paddingBottom: '4px', fontSize: '16px', marginBottom: '8px' }}>Quick Links</h5>
                                         <ul className="list-unstyled m-t10" style={{ lineHeight: '1.9', fontSize: '14.5px', padding: 0, margin: 0 }}>
                                             <li style={{ marginBottom: '14px', padding: '0' }}>
                                                 <Link
                                                     to="/"
                                                     onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                                     style={{ color: '#ffffff', textDecoration: 'none', transition: 'color 0.2s ease', display: 'inline-block' }}
                                                     onMouseEnter={(e) => e.currentTarget.style.color = '#f03a02'}
                                                     onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
                                                 >
                                                     Home
                                                 </Link>
                                             </li>
                                             <li style={{ marginBottom: '14px', padding: '0' }}>
                                                 <Link
                                                     to="/about-us"
                                                     onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                                     style={{ color: '#ffffff', textDecoration: 'none', transition: 'color 0.2s ease', display: 'inline-block' }}
                                                     onMouseEnter={(e) => e.currentTarget.style.color = '#f03a02'}
                                                     onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
                                                 >
                                                     About Us
                                                 </Link>
                                             </li>
                                             <li style={{ marginBottom: '14px', padding: '0' }}>
                                                 <Link
                                                     to="/products"
                                                     onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                                     style={{ color: '#ffffff', textDecoration: 'none', transition: 'color 0.2s ease', display: 'inline-block' }}
                                                     onMouseEnter={(e) => e.currentTarget.style.color = '#f03a02'}
                                                     onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
                                                 >
                                                     Products
                                                 </Link>
                                             </li>
                                             <li style={{ marginBottom: '14px', padding: '0' }}>
                                                 <Link
                                                     to="/projects"
                                                     onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                                     style={{ color: '#ffffff', textDecoration: 'none', transition: 'color 0.2s ease', display: 'inline-block' }}
                                                     onMouseEnter={(e) => e.currentTarget.style.color = '#f03a02'}
                                                     onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
                                                 >
                                                     Projects
                                                 </Link>
                                             </li>
                                             <li style={{ marginBottom: '14px', padding: '0' }}>
                                                 <Link
                                                     to="/contact-us"
                                                     onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                                     style={{ color: '#ffffff', textDecoration: 'none', transition: 'color 0.2s ease', display: 'inline-block' }}
                                                     onMouseEnter={(e) => e.currentTarget.style.color = '#f03a02'}
                                                     onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}
                                                 >
                                                     Contact Us
                                                 </Link>
                                             </li>
                                         </ul>
                                     </div>
                                </div>

                                 {/* CONTACT US */}
                                 <div className="col-lg-4 col-md-7 footer-col-contact">
                                      <div className="widget widget_address_outer" style={{ paddingLeft: '40px' }}>
                                          <h5 className="widget-title text-white" style={{ borderBottom: '2px solid #f03a02', display: 'inline-block', paddingBottom: '4px', fontSize: '17px', marginBottom: '14px', fontWeight: '700' }}>Contact Info</h5>
                                          <ul className="widget_address list-unstyled m-t10" style={{ color: '#ffffff', lineHeight: '1.9', fontSize: '14.5px', margin: 0, padding: 0 }}>
                                              <li style={{ marginBottom: '14px' }}>
                                                  <i className="fa fa-map-marker m-r10" style={{ color: '#E85B24', fontSize: '16px' }} />
                                                  <strong>Office:</strong> 2112, Opp. to TVH Apartments, Trichy Road, Singanallur, <span style={{ whiteSpace: 'nowrap' }}>Coimbatore - 641 005</span>
                                              </li>
                                              <li style={{ marginBottom: '14px' }}>
                                                  <i className="fa fa-industry m-r10" style={{ color: '#E85B24', fontSize: '16px' }} />
                                                  <strong>Factory:</strong> 2015, Louis Philippe Back side, Trichy Road, Singanallur, <span style={{ whiteSpace: 'nowrap' }}>Coimbatore - 641 005</span>
                                              </li>
                                              <li style={{ marginBottom: '14px' }}>
                                                  <i className="fa fa-phone m-r10" style={{ color: '#f03a02', fontSize: '16px' }} />
                                                  <strong>{companyDetails.contactPerson}:</strong> <a href={`tel:${companyDetails.phoneNumbers.primary}`} style={{ color: '#ffffff', textDecoration: 'none', fontWeight: '600' }}>{companyDetails.phoneNumbers.primary}</a>
                                              </li>
                                              <li style={{ marginBottom: '0' }}>
                                                  <i className="fa fa-envelope m-r10" style={{ color: '#f03a02', fontSize: '16px' }} />
                                                  <a href={`mailto:${companyDetails.email}`} style={{ color: '#ffffff', textDecoration: 'none', fontWeight: '600' }}>{companyDetails.email}</a>
                                              </li>
                                          </ul>
                                      </div>
                                 </div>
                            </div>
                        </div>
                    </div>

                    {/* FOOTER COPYRIGHT & DEVELOPER BAR - RESPONSIVE FLEX CONTAINER */}
                    <div className="footer-bottom footer-bottom-bar" style={{ backgroundColor: '#0a0a0a', borderTop: '1px solid #222', paddingTop: '14px', paddingBottom: '14px' }}>
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-12 footer-copyright-row">
                                    <span className="copyrights-text">
                                        &copy; {new Date().getFullYear()} bs clads. All rights reserved.
                                    </span>
                                    <span className="developed-text">
                                        Developed by <a href="https://saitechnosolutions.com" target="_blank" rel="noopener noreferrer" style={{ color: '#f03a02', fontWeight: 'bold', textDecoration: 'none' }}>Sai Techno Solutions</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>

                {/* FLOATING ACTION BUTTONS */}
                <div className="floating-action-btns" style={{ position: 'fixed', bottom: '35px', right: '20px', zIndex: 999999, display: 'flex', flexDirection: 'column', gap: '14px', alignItems: 'center' }}>
                    {/* 1. WhatsApp Chat Floating Button (ALWAYS VISIBLE - FIRST / TOP) */}
                    <a
                        href="https://wa.me/918144370659"
                        target="_blank"
                        rel="noreferrer"
                        className="whatsapp-float-btn"
                        title="Chat on WhatsApp"
                        aria-label="Chat on WhatsApp"
                        style={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            backgroundColor: '#25D366',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '26px',
                            textDecoration: 'none',
                            boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)'
                        }}
                    >
                        <i className="fa fa-whatsapp" />
                    </a>

                    {/* 2. Scroll To Top Floating Button (BELOW WHATSAPP - SECOND / BOTTOM) */}
                    <button
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        title="Scroll to Top"
                        aria-label="Scroll to Top"
                        style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            backgroundColor: '#f03a02',
                            color: '#ffffff',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '18px',
                            boxShadow: '0 4px 15px rgba(240, 58, 2, 0.4)',
                            cursor: 'pointer',
                            opacity: showFloatingBtns ? 1 : 0,
                            visibility: showFloatingBtns ? 'visible' : 'hidden',
                            pointerEvents: showFloatingBtns ? 'auto' : 'none',
                            transition: 'opacity 0.35s ease, visibility 0.35s ease, transform 0.25s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.12)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <i className="fa fa-chevron-up" />
                    </button>
                </div>
            </>
        );
    }
};

export default Footer;